export const CRETESUITE_NAME = 'CreteSuite Crew'

export const IOS_APP_ID = 'id6714483478'
export const ANDROID_PACKAGE_NAME = 'com.cretesuite.crewapp'
export const IOS_STORE_URL = `https://apps.apple.com/app/${IOS_APP_ID}`
export const ANDROID_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`
export const STORAGE_PREFIX = 'capacitor-storage_'
// Must match crew-app v1 so store upgrades keep the operator's session
export const STORAGE_REFRESH_TOKEN_KEY = 'crewcf_refresh_token'
export const STORAGE_DEVICE_ID_KEY = 'crew_device_id'
export const STORAGE_SESSION_ID_KEY = 'crew_session_id'

export const TRACE_HEADERS = {
  DEVICE_ID: 'CS-DID',
  PAGE_ID: 'CS-PID',
  REQUEST_ID: 'CS-RID',
  SESSION_ID: 'CS-SID',
  VERSION: 'CS-VER',
} as const
